export const EXPENDITURE_FORM_DATA = 'EXPENDITURE_FORM_DATA';
export const EXPENDITURE_DROP_DATA = 'EXPENDITURE_DROP_DATA';
export const EXPENDITURE_LIST_DATA = 'EXPENDITURE_LIST_DATA';
export const BANK_ACCOUNTS_LIST = 'BANK_ACCOUNTS_LIST';
export const SET_FILTERS_OPTIONS = 'SET_FILTERS_OPTIONS';
export const CLEAR_EXPENDITURE_FILTER = 'CLEAR_EXPENDITURE_FILTER';
export const UNIMPORTED_EXPENDITURE_LIST_DATA = 'UNIMPORTED_EXPENDITURE_LIST_DATA';
export const SET_FILTERS_OPTIONS_IMPORT = 'SET_FILTERS_OPTIONS_IMPORT';
